/** Durée minimale de l'écran de boot (ms) — laisse jouer l'animation d'entrée. */
export const NATIVE_BOOT_MIN_MS = 2200;

/** Délai max avant de forcer la fermeture (ms). */
export const NATIVE_BOOT_MAX_MS = 5200;

/** Durée du fondu de sortie (ms) — alignée sur native-boot-exit CSS. */
export const NATIVE_BOOT_EXIT_MS = 480;

export type NativeBootGatePhase = 'boot' | 'exit' | 'done';

export interface NativeBootDismissInput {
  isAuthReady: boolean;
  elapsedMs: number;
}

/**
 * Détermine si l'écran de boot peut se fermer.
 */
export function shouldDismissNativeBoot({
  isAuthReady,
  elapsedMs,
}: NativeBootDismissInput): boolean {
  if (elapsedMs >= NATIVE_BOOT_MAX_MS) return true;
  return isAuthReady && elapsedMs >= NATIVE_BOOT_MIN_MS;
}

/**
 * Cold start uniquement : une fois par session JS (pas au resume depuis l'arrière-plan).
 */
let bootCompletedThisSession = false;

export function shouldShowNativeBoot(isNative: boolean): boolean {
  return isNative && !bootCompletedThisSession;
}

export function markNativeBootCompleted(): void {
  bootCompletedThisSession = true;
}

/** Reset pour les tests unitaires. */
export function resetNativeBootSessionForTests(): void {
  bootCompletedThisSession = false;
}
